/**
 * URL helpers shared across features.
 */

/**
 * Return the value only if it is an absolute https URL, otherwise null.
 *
 * Used before rendering DB-sourced URLs (shopper/spot images) as links or
 * `<img src>`: anything else (relative paths, `javascript:`, http) is dropped
 * instead of rendering a broken or unsafe link.
 *
 * @param {string|null|undefined} value
 * @returns {string|null}
 */
export function safeHttpsUrl(value) {
  if (!value) return null;
  try {
    return new URL(value).protocol === 'https:' ? value : null;
  } catch {
    return null;
  }
}
